module.exports = __webpack_public_path__ + "6885fdd4597e70099fd1ae714179a2a2.pdf";